import { render, staticRenderFns } from "./PanelControls.vue?vue&type=template&id=4592cfe6&"
import script from "./PanelControls.vue?vue&type=script&lang=js&"
export * from "./PanelControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4592cfe6', component.options)
    } else {
      api.reload('4592cfe6', component.options)
    }
    module.hot.accept("./PanelControls.vue?vue&type=template&id=4592cfe6&", function () {
      api.rerender('4592cfe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/PanelControls.vue"
export default component.exports